<template>
  <section>
    <b-card-actions title="Notas fiscais de quebra">
      <b-row>
        <b-col md="12">
          <b-table
            ref="invoiceReferences"
            show-empty
            striped
            class="bordered"
            :fields="fields"
            :items="invoiceReferences"
          >
            <template #cell(action)="row">
              <e-grid-actions
                :show-update="false"
                :show-delete="false"
                :buttons="gridButtons(row)"
                @consult-invoice="onUpdateInvoice(row.item)"
              />
            </template>

            <template #cell(status)="row">
              <e-status-badge
                :status="row.item.status"
                :options="statusInvoiceOptions()"
              />
            </template>

          </b-table>
        </b-col>
      </b-row>
    </b-card-actions>
  </section>
</template>

<script>
import { BTable, BRow, BCol } from 'bootstrap-vue'
import { invoiceDomains } from '@/mixins'
import EGridActions from '@/views/components/EGridActions.vue'
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import { EStatusBadge } from '@/views/components'

export default {
  components: {
    BTable,
    BRow,
    BCol,
    BCardActions,
    EStatusBadge,
    EGridActions
  },

  mixins: [invoiceDomains],

  props: {
    stockInventory: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {}
  },

  computed: {
    invoiceReferences() {
      return this.stockInventory?.invoiceReferences || []
    },

    fields() {
      return [
        {
          label: this.$t('Ação'),
          key: 'action',
          class: 'text-center',
          thStyle: { width: '100px' },
        },
        {
          label: this.$t('Número'),
          key: 'invoiceNumber',
          class: 'text-center',
          thStyle: { width: '100px' },
        },
        {
          label: this.$t('Status'),
          key: 'status',
          class: 'text-center',
          thStyle: { width: '150px' },
          formatter: value => this.$t(value),
        },
        {
          label: this.$t('Info. Adicional'),
          key: 'additionalInformation',
          class: 'text-left',
        },
      ].filter(f => !f.hide)
    },
  },

  mounted() { },

  methods: {
    onUpdateInvoice(item) {
      this.$router.push({
        name: 'invoice-maintain',
        params: {
          id: item.id,
          callbackRouteName: this.$route.name,
          inventoryId: this.stockInventory?.id,
        }
      })
    },

    onConsultInvoice(item) {
      this.$router.push({ name: 'invoice-maintain', params: { id: item.id } })
    },

    gridButtons() {
      return [
        {
          icon: 'search',
          variant: 'primary',
          title: this.$t('Consultar Nota Fiscal Gerada'),
          event: 'consult-invoice',
        },
      ]
    },
  },
}
</script>

<style scoped></style>
